"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDynamics = void 0;
exports.AppDynamics = {
    initialize: function (appKey) {
        if (appKey && appKey !== 'ERROR!ERROR!') {
            // Set app dynamics configuration
            var currentWindow = window;
            currentWindow['adrum-start-time'] = new Date().getTime();
            if (!currentWindow['adrum-config']) {
                currentWindow['adrum-config'] = {};
            }
            var config = currentWindow['adrum-config'];
            config.appKey = appKey;
            config.adrumExtUrlHttp = 'http://cdn.appdynamics.com';
            config.adrumExtUrlHttps = 'https://cdn.appdynamics.com';
            config.beaconUrlHttp = 'http://pdx-col.eum-appdynamics.com';
            config.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com';
            config.resTiming = { bufSize: 200, clearResTimingOnBeaconSend: true };
            config.maxUrlLength = 512;
            config.page = { captureTitle: true };
            config.xd = { enable: false };
            config.fetch = true;
            config.spa = {
                spa2: true,
            };
            // Add adrum script to the header
            var head = document.getElementsByTagName('head');
            var titleTag = document.querySelector('head title');
            if (head) {
                var script = document.createElement('script');
                script.src = 'https://cdn.appdynamics.com/adrum/adrum-latest.js';
                script.type = 'text/javascript';
                script.charset = 'UTF-8';
                script.async = false;
                if (titleTag) {
                    titleTag.parentNode.insertBefore(script, titleTag.nextSibling);
                }
                else {
                    head[0].appendChild(script);
                }
            }
        }
    },
};
